/**
 * Thin wrapper that mounts ReportsTabCN scoped to the current portfolio.
 *
 * Linear: MYD-341 (Phase 4).
 */

import { useParams } from 'react-router-dom'
import ReportsTabCN from 'features/Reports/ReportsTabCN'

const PortfolioReports = () => {
	const { id } = useParams<{ id: string }>()
	if (!id) return null
	return (
		<ReportsTabCN
			scope="portfolio"
			entityId={id}
			heading="Portfolio reports"
			subhead="Generate a one-page Summary for board/quarterly reviews, or a multi-page Story as the client deliverable for site-selection engagements. Reports land here and on the Documents tab."
		/>
	)
}

export default PortfolioReports
